import { type Common } from './common.js';
import {
  type CreateValues,
  type DecisionTree,
  type FindAllOptions,
  type UpdateValues,
} from './models/decisionTree.js';
import { type PaginatedQueryOptions, type PaginationResponse } from './models/pagination/index.js';

export class API {
  common: Common;
  baseEndpoint = '/decision-trees';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<DecisionTree> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<DecisionTree>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options?: FindAllOptions): Promise<DecisionTree[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async create(createValues: CreateValues): Promise<DecisionTree> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, createValues);
  }

  async update(id: string, updateValues: UpdateValues): Promise<DecisionTree> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, updateValues);
  }
}
